import { IconProps } from '../../types/components';

export const ProductLogo = ({
  primaryColor = 'white',
  secondaryColor = '#A678CE',
  cy,
}: IconProps) => {
  return (
    <svg
      width="25"
      height="37"
      viewBox="0 0 25 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-cy={cy}
    >
      <path
        d="M21.0716 15.9064L12.5558 31.8017L3.8826 16.0101C3.77855 15.8199 3.6222 15.6609 3.4306 15.5504C3.239 15.4399 3.01951 15.3821 2.79604 15.3833L0 15.3999C0.00504711 15.4181 0.00763051 15.4367 0.0139146 15.4552C0.0396906 15.5438 0.0768306 15.6289 0.124485 15.7086L10.982 35.1315C11.1281 35.3847 11.3565 35.5881 11.6672 35.7417C11.9601 35.8918 12.2922 35.9562 12.6227 35.9268C13.3123 35.8947 13.8014 35.6235 14.09 35.1131L24.6617 15.5629C24.6953 15.4559 24.7389 15.352 24.792 15.2526L22.1494 15.2683C21.9263 15.2697 21.7079 15.33 21.5178 15.4425C21.3278 15.555 21.1735 15.7154 21.0716 15.9064Z"
        fill={primaryColor}
      />
      <path
        d="M2.56563 11.7033C2.82172 11.7031 3.06883 11.6126 3.26008 11.4488C3.45133 11.285 3.57341 11.0594 3.60315 10.8148C4.13817 6.47141 7.68081 3.10312 12.3524 3.10312C17.0239 3.10312 20.7892 6.47457 21.3506 10.8204C21.3814 11.0641 21.5041 11.2885 21.6953 11.4512C21.8866 11.6139 22.1332 11.7036 22.3885 11.7033H24.8072C24.673 5.22873 19.1187 0 12.354 0C5.5893 0 0.134578 5.22873 0 11.7033H2.56563Z"
        fill={secondaryColor}
      />
    </svg>
  );
};
